<template>
  <v-container fluid>
    <v-container>
      <v-row class="justify-center align-center" style="min-height: 20vh;">
        <v-col cols="auto">
          <h1 v-if="isLoading" class="text-center">{{ $t("transactionsCheckPayment") }}</h1>
          <h1 v-else-if="error" class="text-center">{{ $t("transactionsPaymentError") }}</h1>
          <h1 v-else class="text-center">{{ $t("transactionsPaymentSuccessfully") }}</h1>
        </v-col>
      </v-row>
      <v-row class="justify-center align-center">
        <v-col cols="auto">
          <v-progress-circular
              v-if="isLoading"
              indeterminate
              color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";

export default {
  name: "CheckPayment",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  data() {
    return {
      isLoading: true,
      error: false
    };
  },

  created() {
    this.pollPaymentStatus(this.$route.params.payment_id);
  },

  methods: {
    ...mapActions(["checkPayment"]),
    pollPaymentStatus(paymentId) {
      this.checkPayment({payment_id: paymentId}).then((response) => {
        this.isLoading = true
        if (response.data.status === 'processing') {
          setTimeout(() => this.pollPaymentStatus(paymentId), 5000);
        } else if (response.data.status === 'paid') {
          this.isLoading = false
        }
      }).catch(() => {
        this.isLoading = false
        this.error = true
      });
    }
  },
};
</script>
